import AnswerPreview from './answer_preview';
export default AnswerPreview;
